"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.warn = warn;
exports.setLogger = setLogger;
let logger = console;
function warn(message) {
    if (logger) {
        logger.warn(message);
    }
}
function setLogger(newLogger) {
    logger = newLogger;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL2xvZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQU1BLG9CQUlDO0FBRUQsOEJBRUM7QUFWRCxJQUFJLE1BQU0sR0FBNEIsT0FBTyxDQUFDO0FBRTlDLFNBQWdCLElBQUksQ0FBQyxPQUFlO0lBQ2xDLElBQUksTUFBTSxFQUFFLENBQUM7UUFDWCxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ3ZCLENBQUM7QUFDSCxDQUFDO0FBRUQsU0FBZ0IsU0FBUyxDQUFDLFNBQXlCO0lBQ2pELE1BQU0sR0FBRyxTQUFTLENBQUM7QUFDckIsQ0FBQyJ9